module.exports = "../dist/img/product-detail-3-24.f017.jpg";